import gql from 'graphql-tag';

const GET_SERVICE_RUN_RECONCILIATION_INSIGHTS = gql`
	query($id: String) {
		getServiceRun(id: $id) {
			id
			reconciliationInsights {
				driverLastRuns {
					runId
					planned
					docketCount
					totalExpected
					totalCollected
					totalVariance
					totalMissing
				}
				driverLastDockets {
					serviceDocketId
					serviceRunId
					machineId
					machineAssetId
					date
					expected
					collected
					variance
				}
				machineLastCollections {
					machineId
					machineAssetId
					collectionsCount
					negativeVarianceCount
					totalExpected
					totalMissing
					missingRate
					lastCollectionDate
					lastVariance
				}
				benchmark {
					comparisonWindowDays
					driverDocketCount
					fleetDocketCount
					driverMissingRate
					fleetMissingRate
					driverPercentile
					fleetDriverCount
				}
			}
		}
	}
`;

export default GET_SERVICE_RUN_RECONCILIATION_INSIGHTS;
